/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobForwardingCheckRequest {
    getFixupPrototypeFunction() { return BackgroundJobForwardingCheckRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobForwardingCheckRequest>): BackgroundJobForwardingCheckRequest {
        let obj = Object.assign(new BackgroundJobForwardingCheckRequest(), model);
        BackgroundJobForwardingCheckRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobForwardingCheckRequest>): BackgroundJobForwardingCheckRequest {
        if (!model) return null;
        return BackgroundJobForwardingCheckRequest.newInstance(<BackgroundJobForwardingCheckRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobForwardingCheckRequest) {
        if (!obj) return;

        models.BackgroundJobForwardingCheckRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobForwardingCheckRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobForwardingCheckRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Target Executor for the job
     */
    target_executor: models.BackgroundJobExecutor;

    /**
     * Path of the request
     */
    path_executors: Array<models.BackgroundJobExecutor>;

}
